






































































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { onlineBookingSlotsFields } from '@/config/schedule-config';
import BpcFormProvider from '@shared/components/forms/form-provider.vue';
import BpcInput from '@shared/components/forms/inputs/input/input.vue';
import BpcMultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import BpcEntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import BpcSection from '@shared/components/forms/inputs/section/section.vue';
import BpcCheckboxGroup from '@shared/components/forms/inputs/checkbox-group/checkbox-group.vue';
import {
  OnlineBookingSlotGeneratorErrorObject,
  OnlineBookingSlotGeneratorFormModel,
  WeekDay,
  SlotDuration,
  DayType,
} from '@bookings/interfaces/schedule';
import BpcScheduleOnlineBookingSlotGrid from './schedule-online-booking-slot-grid.vue';

@Component({
  name: 'bpc-schedule-slots-generator-modal-form',
  components: {
    BpcFormProvider,
    BpcInput,
    BpcMultiSelect,
    BpcEntitySelect,
    BpcSection,
    BpcScheduleOnlineBookingSlotGrid,
    BpcCheckboxGroup,
  },
})
export default class ScheduleSlotsGeneratorModal extends Vue {
  // @Prop(Object) readonly value: OnlineBookingSlotGeneratorFormModel;
  @Prop(Boolean) readonly showModal: boolean;
  @Prop(String) readonly dayType: DayType;
  @Prop(Number) readonly slotDuration: SlotDuration;
  @Prop(Object) readonly value: OnlineBookingSlotGeneratorFormModel;

  get generatorFormModel() {
    return this.value;
  }

  set generatorFormModel(value: OnlineBookingSlotGeneratorFormModel) {
    this.$emit('input', value);
  }

  loading = false;
  errorsObject: OnlineBookingSlotGeneratorErrorObject = {};
  showSlotPriceCategoryError = false;
  get fieldsConfig() {
    return onlineBookingSlotsFields;
  }

  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 pl-2': true,
        },
      },
    };
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 pl-2': true,
        },
      },
    };
  }

  get weekDaysRange(): string {
    return this.generatorFormModel?.week_days_range;
  }

  manageSaveErrors(errors: any) {
    this.errorsObject = {};
    Object.keys(errors).forEach(key => {
      this.$set(this.errorsObject, key, errors[key]);
    });
  }

  getSelectedWeekDaysFromRange(): WeekDay[] {
    const weekDaysRange = this.generatorFormModel.week_days_range;
    if (weekDaysRange === 'mon_fri') {
      return ['mon', 'tue', 'wed', 'thu', 'fri'];
    }
    if (weekDaysRange === 'fri_sun') {
      return ['fri', 'sat', 'sun'];
    }
    if (weekDaysRange === 'sat_sun') {
      return ['sat', 'sun'];
    }
    if (weekDaysRange === 'mon_sun') {
      return ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
    }
    if (weekDaysRange === 'custom') {
      return this.generatorFormModel.selected_week_days;
    }

    return ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
  }

  onSlotPriceCategoryChange(event) {
    console.log('onPriceCategoryChange', event);
  }

  onSlotPriceCategoryLoaded(items) {
    if (!this.generatorFormModel.slot_price_category && items.length === 1) {
      this.generatorFormModel.slot_price_category = items[0];
    }
  }
  generate() {
    if (this.generatorFormModel.slot_price_category === null) {
      this.showSlotPriceCategoryError = true;
      return;
    }
    this.showSlotPriceCategoryError = false;
    this.generatorFormModel.slot_duration = this.slotDuration;
    this.generatorFormModel.day_type = this.dayType;
    this.$emit('generate', this.generatorFormModel);
  }

  close() {
    this.$emit('close');
  }

  @Watch('weekDaysRange')
  onWeekDaysRangeChange() {
    this.generatorFormModel.selected_week_days = this.getSelectedWeekDaysFromRange();
  }
}
